import React, { createContext, useContext } from 'react';

import PropTypes from 'prop-types';

/**
 * @typedef { Pick<import('./types').Props, 'onAction' | 'onSubmit'> } ActionProps
 */

/**
 * @type { React.Context<ActionProps & { dataloader: unknown }> }
 */
const ForecasterContext = createContext({
	onAction: () => null,
	onSubmit: () => null,
	dataloader: null,
});

/** @type { React.FC<React.PropsWithChildren<ActionProps & { dataloader: unknown }>> } */
const Mixin = React.memo(function ForecasterContextProvider(props) {
	const { onAction, onSubmit, dataloader, children } = props;

	const ctx = useContext(ForecasterContext);

	const next = React.useMemo(() => {
		const base = { ...ctx };

		if (onAction) {
			base.onAction = onAction;
		}

		if (onSubmit) {
			base.onSubmit = onSubmit;
		}

		if (dataloader) {
			base.dataloader = dataloader;
		}

		return base;
	}, [ctx, dataloader, onAction, onSubmit]);

	return (
		<ForecasterContext.Provider value={next}>
			{children}
		</ForecasterContext.Provider>
	);
});

Mixin.propTypes = {
	onAction: PropTypes.func,
	onSubmit: PropTypes.func,
	dataloader: PropTypes.any,
	children: PropTypes.node,
};

export { Mixin as ForecasterContextMixin, ForecasterContext };
